<template>
  <div>
    <NuxtRouteAnnouncer />
    <div id="nav-header"></div>
    <div
      id="loyallist-container"
      class="grid-x lh-grid-container cell"
      :class="{ 'large-padding-top-l': showLeftNav }"
    >
      <div
        v-if="showLeftNav"
        class="cell small-12 large-3 show-for-large large-padding-right-s"
      >
        <LeftNav class="grid-container" />
      </div>
      <div
        class="cell small-12"
        :class="showLeftNav ? 'large-9' : 'large-12'"
      >
        <NuxtPage />
      </div>
    </div>
    <div id="nav-footer"></div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import LeftNav from './components/LeftNav.vue';
import sessionTimeOutHandler from './utils/interceptors/SessionTimeOutHandler';
import { useEnvPropsStore } from './stores/useEnvPropsStore';

const route = useRoute();
const envPropsStore = useEnvPropsStore();

const envProps = computed(() => envPropsStore);

const showLeftNav = computed(() => !route?.meta?.hideLeftNav);

const ensureHeaderFooterScript = () => {
  if (!import.meta.client) {
    return;
  }
  if (document.querySelector('script[data-loyallist-nav-header-footer="true"]')) {
    return;
  }
  const hostPrefix = (envProps.value?.navigationHostLink || '').replace(/\/$/, '');
  if (!hostPrefix) {
    return;
  }
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `${hostPrefix}/navigation/header-footer?csrJS=true`;
  script.setAttribute('data-loyallist-nav-header-footer', 'true');
  script.onload = () => {
    try {
      if (typeof window !== 'undefined' && typeof window.__LOAD_NAVIGATION_SCRIPTS__ === 'function') {
        window.__LOAD_NAVIGATION_SCRIPTS__();
      }
    } catch {
      // no-op: avoid breaking app if host script internals change
    }
  };
  script.async = true;
  document.body.appendChild(script);
};

onBeforeMount(() => {
  if (!import.meta.client) {
    return;
  }
  sessionTimeOutHandler();
});

onMounted(async () => {
  if (!import.meta.client) {
    return;
  }
  ensureHeaderFooterScript();
  // Adobe auto-tagging for active experiments (parity with legacy Vue app).
  try {
    const { ExperimentationTags } = await import('@nuxt-common/util/app/utils/experimentation');
    await ExperimentationTags.fireAdobeTags();
  } catch {
    /* tagging must never break the app */
  }
});
</script>

<style lang="scss">
@import '~appSCSS';
</style>



<style lang="scss" brand="bcom">
@import '~@core/csg/src/scss/settings/bcom.scss';

.left-nav {
  font-family: $body-font-family;
  margin-left: rem-calc(2px) !important;

  .submenu {
    p {
      margin-bottom: 0;
    }

    a:hover {
      color: #d90eac;
    }
  }

  .left-nav-header-wrapper {
    display: none;
  }

  h2 {
    font-size: $h2-font-size;
    line-height: $h2-line-height;
  }

  .accordion-medium p {
    text-transform: none;
  }
}
</style>
<style lang="scss" scoped>
#loyallist-container {
  &.lh-grid-container {
    @include breakpoint(large up) {
      max-width: rem-calc(1600px);
    }

    @media screen and (min-width: 100em) {
      padding-right: 5rem;
      padding-left: 5rem;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>